/*
INTELLECTUAL PROPERTY NOTICE
© Kaleida Ltd. All rights reserved.
This file contains Protected Intellectual Property owned by Kaleida Ltd and forms part of an application developed by Kaleida within the Platform.
Protected Intellectual Property may only be used as incorporated within applications developed by Kaleida within the Platform and must not be used, reproduced, adapted, or incorporated into any application developed by or on behalf of the Customer (explicitly not developed by Kaleida), whether or not such application forms part of the Platform.
For the avoidance of doubt, the inclusion of any application within the Platform does not of itself grant any right to use Protected Intellectual Property in that application unless that application was developed by Kaleida.
*/

// IP-NOTICE: PROTECTED
import { Constants } from 'app/core/models/constants';
import { CookieService } from '../services/cookie.service';

export function setTinyMceTabIndex(startTabIndex: number, cookieService: CookieService) {
  const baseSettings = Constants.EditorSettings.FullSettings(cookieService);

  return {
    ...baseSettings,
    tabindex: startTabIndex,
    setup: (editor: any) => {
      if (baseSettings.setup) baseSettings.setup(editor);

      editor.on('init', () => {
        setTimeout(() => {
          const iframe = document.querySelector('iframe.tox-edit-area__iframe');
          if (iframe) iframe.setAttribute('tabindex', String(startTabIndex));

          const editable = document.querySelector('.tox-edit-area [contenteditable="true"]');
          if (editable) editable.setAttribute('tabindex', String(startTabIndex));
        });
      });
    },
  };
}